import { Component, Input } from '@angular/core';

@Component({
  selector: 'renci-home-table-footer',
  templateUrl: './home-table-footer.component.html',
  styleUrls: ['./home-table-footer.component.css']
})
export class HomeTableFooterComponent {

  public message: string;

  @Input('data')
  public set data(value: any) {
    if (value.error) {
      this.message = 'Error Occured';
    } else if (value.totalItems > 0) {
      const firstRecordCount = (value.currentPage - 1) * value.itemsPerPage + 1;
      const lastRecordCount = Math.min(value.currentPage * value.itemsPerPage, value.totalItems);
      this.message = `Showing ${firstRecordCount} to ${lastRecordCount} of ${value.totalItems} records`;
    } else {
      this.message = 'No records';
    }
  }
}
